module.exports = __webpack_public_path__ + "img/weixin-account.0536aadb.png";